export const GET_CREDIT_CODE_VALUE = "getCreditCodeValue"

export default {
  [GET_CREDIT_CODE_VALUE]: (state: CreditCode): number | null => state.creditCodeValue
}
